export default "__VITE_ASSET__940b8995__"